"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemStatusAndTooltip = exports.getJobStatusTooltip = exports.getStatusTranslation = void 0;
var react_1 = __importDefault(require("react"));
var string_1 = require("@utils/string");
var Tooltip_1 = require("@components/Tooltip");
var lodash_1 = __importDefault(require("lodash"));
var date_1 = require("@utils/date/date");
var react_i18next_1 = require("react-i18next");
var job_1 = require("@common/model/job");
var getRefusalReasons_1 = require("@/react-app/features/ItemCommon/utils/getRefusalReasons");
var getStatusTranslation = function (status, actorDomain) {
    var jobStatus = (0, job_1.getFullJobStatus)(status, actorDomain);
    return "itemLog:TABLE.ITEM.STATUS_LIST.".concat(jobStatus);
};
exports.getStatusTranslation = getStatusTranslation;
// TO DO verify which are the correct values to render
// There is the difference between  STATUS_LIST  values and STATUS_TOOLTIP values may be the angular part is wrong
// in STATUS_LIST deferred value is Escalated and in STATUS_TOOLTIP is deferred value is Reviewable
// escalated and processing keys does not exist in STATUS_TOOLTIP
var getJobStatusTooltip = function (status, actor) {
    var timeZone = (0, date_1.getUserTimezone)();
    var humanActor = lodash_1.default.includes(['client', 'agent'], actor === null || actor === void 0 ? void 0 : actor.domain) ? actor === null || actor === void 0 ? void 0 : actor.id : null;
    var by = humanActor ? "by ".concat(humanActor) : '';
    var timePrep = status === 'reviewable' || status === 'new' || status === 'processing' ? 'since' : 'at';
    return { timeZone: timeZone, humanActor: humanActor, by: by, timePrep: timePrep };
};
exports.getJobStatusTooltip = getJobStatusTooltip;
function ItemStatusAndTooltip(_a) {
    var _b, _c;
    var job = _a.job, customStatusTextClassName = _a.customStatusTextClassName;
    var t = (0, react_i18next_1.useTranslation)().t;
    var jobStatus = job.getStatus() || '';
    var actor = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.current.actor;
    var actorDomain = actor === null || actor === void 0 ? void 0 : actor.domain;
    var _d = (0, exports.getJobStatusTooltip)(jobStatus, actor), timeZone = _d.timeZone, by = _d.by, timePrep = _d.timePrep;
    var translationKey = (0, exports.getStatusTranslation)(jobStatus, actorDomain);
    var statusTranslation = t(translationKey);
    var refusalReason = (0, getRefusalReasons_1.getRefusalReasons)(job);
    var refusalReasonText = refusalReason ? " (".concat(refusalReason, ")") : '';
    return (react_1.default.createElement("td", { className: "jobs-table-content-cell job-table-content-cell-status eva-tooltip-container--center" },
        react_1.default.createElement("div", { className: "item-log-status-text item-status-text__".concat((0, string_1.replaceSpaceWithDash)(job.getStatus()), " ").concat(customStatusTextClassName) },
            statusTranslation + refusalReasonText,
            react_1.default.createElement(Tooltip_1.Tooltip, null, "".concat(jobStatus === 'escalated' ? 'Escalated' : statusTranslation + refusalReasonText, " ").concat(by, " ").concat(timePrep, " ").concat((0, date_1.formatDate)(new Date(((_c = job === null || job === void 0 ? void 0 : job.ad) === null || _c === void 0 ? void 0 : _c.history[0].timestamp) || 0)), " ").concat(timeZone)))));
}
exports.ItemStatusAndTooltip = ItemStatusAndTooltip;
